import { Component, Input, ViewChild } from "@angular/core";
import { ProductAttributes } from "@models/product.model";
import { RightNavbarComponent } from '../../dashboard/right-navbar/right-navbar.component';

@Component({
    selector: "app-feature-product",
    templateUrl: "./feature-product.component.html",
    styleUrl: "./feature-product.component.scss",
    standalone: false,
})
export class FeatureProductComponent {
    @Input() featuredProducts: ProductAttributes[] = [];
    @ViewChild(RightNavbarComponent) rightNavbarComponent!: RightNavbarComponent;

    public isNavbarOpen: boolean = false;

    public setNavbarOpen(isOpen: boolean): void {
      this.isNavbarOpen = isOpen;
    }

    public onCloseNavbar() {
      this.isNavbarOpen = false;
    }

}
